
<mcg-window #form [loading]="loading()" (actionButtonClicked)='actionButtonClicked($event)' [width]="800" [height]="600" [actions]="actions" [canResize]="false"
  (windowClosed)="onClose()"  [title]="translate('Subflotas') + ' (' + subflotas.length + ')'" (onClose)="onClose()">

    <div>
      <app-header #header [buscador]="true" [filtro]="true" [resetFiltro]="true" (eventBuscador)="onBuscar()"
        (eventFilter)="eventFilter()" (eventResetFilter)="eventResetFilter()">
      </app-header>
    </div>
    <div class="content_grid">
      <jqxGrid #grid [theme]="environment.tema" [width]="'100%'" [height]="'100%'" [source]="dataAdapterSubflotas"
        [appCellClick] [columnsresize]="true" [filterable]="true" [showfilterrow]="false" [columns]="columnsSubflotas"
        [sortable]="true" [altrows]="true" [showrowlines]="false" [filterrowheight]="30" [rowsheight]="25"
        [columnsheight]="25" [enablebrowserselection]="true" [showemptyrow]="true" [localization]="langGrid"
        [filter]="filter" (onSort)="onSort($event)" [updatefilterconditions]="updatefilterconditions"
        [rowdetails]="true" [rowdetailstemplate]="rowdetailstemplate" [initrowdetails]="initRowDetails"
        (onRowexpand)="rowexpand($event)" (onRowcollapse)="rowcollapse($event)"
        (onRowclick)="onRowSubflotaSelect($event)" (onRowdoubleclick)="onRowdoubleclick($event)"
        (onBindingcomplete)="subflotaBindingComplete()">
      </jqxGrid>
    </div>

</mcg-window>

<app-form-subflota
  *ngIf="mostrarEditForm"
  [subflotaEdit]="subflotaEdit"
  [movilesLibres]="movilesLibres"
  (subflotaEdited)="updateGrid($event)"
  (formClosed)="onCloseEdit()"
>
</app-form-subflota>
